import React, { FC, HTMLAttributes } from 'react';
import styles from './Date.module.scss';
import { format, parse } from 'fecha';
import cx from 'classnames';
import { Locales, type TLocale } from 'src/lib/constants';

interface Props extends HTMLAttributes<HTMLParagraphElement> {
  date: string;
  isUpdatedDate?: boolean;
  useDateStyles?: boolean;
  locale?: TLocale;
}

const Date: FC<Props> = ({
  date: dateString,
  isUpdatedDate = false,
  useDateStyles = false,
  locale = Locales.EN_US,
  className,
  ...rest
}) => {
  try {
    const formattedDate = format(
      parse(dateString, 'YYYY-MM-DD'),
      locale === Locales.EN_US ? 'MMMM DD, YYYY' : 'D MMMM YYYY',
    );

    return (
      <p
        className={cx(
          styles.date,
          isUpdatedDate && !useDateStyles && styles.updatedDate,
          className,
        )}
        {...rest}
      >
        {`${isUpdatedDate ? 'Updated on ' : ''}${formattedDate}`}
      </p>
    );
  } catch (e) {
    return null;
  }
};

const UpdatedDate: FC<Omit<Props, 'isUpdatedDate' | 'useDateStyles'>> = ({
  date,
  ...rest
}) => {
  return <Date date={date} isUpdatedDate {...rest} />;
};

export { Date, UpdatedDate };
